import React from "react";
import "./style.css";

export default props => {
  return <div className="botao" {...props}>{props.texto}</div>;
};
